"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePrefetchMenu = exports.useMenu = void 0;

var _reactQuery = require("react-query");

var _api = require("../api");

var useMenu = function useMenu(_a) {
  var locationNumber = _a.locationNumber,
      serviceMethod = _a.serviceMethod;
  return (0, _reactQuery.useQuery)("Menu"
  /* Menu */
  , function () {
    return (0, _api.fetchMenu)(locationNumber, serviceMethod);
  }, {
    enabled: !!locationNumber && !!serviceMethod,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false
  });
};

exports.useMenu = useMenu;

var usePrefetchMenu = function usePrefetchMenu(_a) {
  var locationNumber = _a.locationNumber,
      serviceMethod = _a.serviceMethod;
  var queryClient = (0, _reactQuery.useQueryClient)();
  return function () {
    return queryClient.prefetchQuery("Menu"
    /* Menu */
    , function () {
      return (0, _api.fetchMenu)(locationNumber, serviceMethod);
    }, {
      staleTime: 30 * 1000
    });
  };
};

exports.usePrefetchMenu = usePrefetchMenu;